import { Box } from "@mui/material"
import AboutCM from "./AboutCM"
import Contact from "./Contact"

const About = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center' }}>
      <AboutCM/>
      <Contact/>
    </Box>
  )
}

export default About
